import mixpanel from 'mixpanel-browser';

type NewPostFromType =
    | 'main_cta_calendar'
    | 'main_cta_feed'
    | 'time_slot'
    | 'media_drop'
    | 'quick_access'
    | 'media_library'
    | 'content_inspiration_idea_card';

export function mixPanelSchedulerNewPost(event: NewPostFromType) {
    // prevent mixpanel from sending events in test environment
    if (process.env.NODE_ENV === 'test') {
        return;
    }
    mixpanel?.track('mixpanel_post_creation_started', {
        origin: event
    });
}
